// slick is lazy-loaded in app.js only when certain sliders exist — this page needs it explicitly.
require('slick-carousel');
const {onModeEnter, onModeLeave, getMode} = require('../../media.js');
import CustomizeThemeTemplates from "../booking-templates/customize-theme-templates"

new CustomizeThemeTemplates();

function loadMoreTemplates() {
    $(function () {
        var $countItems = $(".templates-items--list .templates-items--list-item");
        $countItems.slice(0, 9).show();

        $(".loadMoreItems").on('click', function (e) {
            e.preventDefault();
            $countItems.removeClass('scroll-here');
            $(".templates-items--list .templates-items--list-item:hidden").slice(0, 1).addClass('scroll-here');
            $(".templates-items--list .templates-items--list-item:hidden").slice(0, 3).slideDown();

            if ($(".templates-items--list .templates-items--list-item:hidden").length == 0) {
                $(".loadMoreItems").fadeOut('slow');
            }

            $('html,body').animate({
                scrollTop: $(".templates-items--list .templates-items--list-item.scroll-here").offset().top - 100
            }, 1500);
        });
    });
}

loadMoreTemplates();

// Theme selection persistence — read side. When a user picks a theme on the
// homepage's #templates section (see app.js, which sets localStorage there —
// that section renders on the old homepage template, not this page) and is
// redirected here, the chosen theme ID is auto-scrolled to and activated.
var localStorageData = localStorage.getItem('selectedTheme');
if ( $('.templates-items--section').length ) {
    let items = $('.templates-items--section .templates-items--list-item');
    var selectedButton = items.filter(function () {
        return $(this).find('.anchor-link').data('theme-id') == localStorageData;
    }).find('.anchor-link');

    $(document).ready(function () {
        setTimeout(function () {
            selectedButton.trigger('click');
            localStorage.removeItem('selectedTheme');
        }, 1500);
    });
}
